// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__16hgt","header":"MessagesList_header__Ee1DG","chat":"MessagesList_chat__ciuhv"};